export const EARLIEST_RELEASE_NOTES_MONTH = '2026-01';

const MONTH_LABEL_FORMATTER = new Intl.DateTimeFormat('en', {
  month: 'short',
  year: 'numeric',
});

function getMonthStartDate(monthKey: string) {
  const [year, month] = monthKey.split('-').map(Number);
  return new Date(year, month - 1, 1);
}

export function getPreviousMonthKey(offset: number, now = new Date()) {
  const monthDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1 - offset, 1));
  return monthDate.toISOString().slice(0, 7);
}

export function getMonthKeys(monthCount: number, now = new Date()) {
  return Array.from({ length: monthCount }, (_, index) => getPreviousMonthKey(index, now)).filter(
    monthKey => monthKey >= EARLIEST_RELEASE_NOTES_MONTH
  );
}

export function getMonthLabel(monthKey: string) {
  return MONTH_LABEL_FORMATTER.format(getMonthStartDate(monthKey)).replace(/^(.{3})(\s)/, '$1.$2');
}

export function hasMoreReleaseNotesMonths(monthKeys: string[]) {
  const oldestLoadedMonth = monthKeys[monthKeys.length - 1];
  return oldestLoadedMonth !== undefined && oldestLoadedMonth > EARLIEST_RELEASE_NOTES_MONTH;
}
